import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import Service from "@/services/AlatReuseService";
import {
  MasterAlatReuse,
  PenggunaanAlatReuse,
  KerusakanAlatReuse,
  CanReuseResponse
} from "@/types/alat_reuse";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "alat-reuse"
})
class AlatReuseModule extends VuexModule {
  masterList: MasterAlatReuse[] = [];
  penggunaanList: PenggunaanAlatReuse[] = [];
  kerusakanList: KerusakanAlatReuse[] = [];
  currentCanReuse: CanReuseResponse | null = null;
  loading = false;
  pagination = {
    currentPage: 1,
    lastPage: 1,
    perPage: 20,
    total: 0
  };

  @Mutation SET_MASTER(list: MasterAlatReuse[]) { this.masterList = list; }
  @Mutation SET_PENGGUNAAN(list: PenggunaanAlatReuse[]) { this.penggunaanList = list; }
  @Mutation SET_KERUSAKAN(list: KerusakanAlatReuse[]) { this.kerusakanList = list; }
  @Mutation SET_CAN_REUSE(v: CanReuseResponse | null) { this.currentCanReuse = v; }
  @Mutation SET_LOADING(v: boolean) { this.loading = v; }
  @Mutation SET_PAGINATION(v: any) { this.pagination = v; }

  // ---------- Master ----------
  @Action
  async loadMaster(params?: any) {
    this.SET_LOADING(true);
    try {
      const res = await Service.masterList({ params });
      const d = res.data.data;
      this.SET_MASTER(d.data || d || []);
      if (d.current_page) {
        this.SET_PAGINATION({
          currentPage: d.current_page,
          lastPage: d.last_page,
          perPage: d.per_page,
          total: d.total
        });
      }
    } finally {
      this.SET_LOADING(false);
    }
  }

  @Action
  async createMaster(data: any) {
    const res = await Service.masterCreate(data);
    return res.data.data;
  }

  @Action
  async updateMaster(payload: { id: number; data: any }) {
    const res = await Service.masterUpdate(payload.id, payload.data);
    return res.data.data;
  }

  @Action
  async deleteMaster(id: number) {
    await Service.masterDestroy(id);
  }

  // ---------- Penggunaan ----------
  @Action
  async loadPenggunaan(params?: any) {
    this.SET_LOADING(true);
    try {
      const res = await Service.penggunaanList({ params });
      const d = res.data.data;
      this.SET_PENGGUNAAN(d.data || d || []);
      if (d.current_page) {
        this.SET_PAGINATION({
          currentPage: d.current_page,
          lastPage: d.last_page,
          perPage: d.per_page,
          total: d.total
        });
      }
    } finally {
      this.SET_LOADING(false);
    }
  }

  @Action
  async createPenggunaan(data: any) {
    const res = await Service.penggunaanCreate(data);
    return res.data.data;
  }

  @Action
  async updatePenggunaan(payload: { id: number; data: any }) {
    const res = await Service.penggunaanUpdate(payload.id, payload.data);
    return res.data.data;
  }

  @Action
  async deletePenggunaan(id: number) {
    await Service.penggunaanDestroy(id);
  }

  @Action
  async checkReuseStatus(payload: { masterAlatId: number; kodeUnit?: string }) {
    const res = await Service.penggunaanStatus(payload.masterAlatId, payload.kodeUnit);
    const data = res.data.data as CanReuseResponse;
    this.SET_CAN_REUSE(data);
    return data;
  }

  @Action clearCanReuse() { this.SET_CAN_REUSE(null); }

  // ---------- Kerusakan ----------
  @Action
  async loadKerusakan(params?: any) {
    this.SET_LOADING(true);
    try {
      const res = await Service.kerusakanList({ params });
      const d = res.data.data;
      this.SET_KERUSAKAN(d.data || d || []);
      if (d.current_page) {
        this.SET_PAGINATION({
          currentPage: d.current_page,
          lastPage: d.last_page,
          perPage: d.per_page,
          total: d.total
        });
      }
    } finally {
      this.SET_LOADING(false);
    }
  }

  @Action
  async createKerusakan(data: any) {
    const res = await Service.kerusakanCreate(data);
    return res.data;
  }

  @Action
  async updateKerusakan(payload: { id: number; data: any }) {
    const res = await Service.kerusakanUpdate(payload.id, payload.data);
    return res.data.data;
  }

  @Action
  async deleteKerusakan(id: number) {
    await Service.kerusakanDestroy(id);
  }
}

export default getModule(AlatReuseModule);
